import { Modes } from '@/models/modes';

const initialState = () => ({
  mode: Modes.INBOX.name,
  status: {
    error: null,
    pending: true,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  setMode({ commit }, { mode }) {
    commit('SET_MODE', mode.name);

    if (!mode) {
      commit('SET_MODE', '');
    }
  },
};

const mutations = {
  SET_MODE(state, mode) {
    state.mode = mode;
  },
};

const getters = {
  mode: (state) => state.mode,

  // status
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const modes = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
